import { WebsocketServerEvent } from '@activepieces/shared';
import { io } from 'socket.io-client';

import { API_BASE_URL } from '@/lib/api-constants';

export const socket = io(API_BASE_URL, {
  transports: ['websocket'],
  path: '/api/socket.io',
  autoConnect: false,
});

/**
 * The access token lives one hour while a tab stays open longer: the refreshed
 * token goes over the live connection (an in-flight AI turn keeps its socket)
 * and is kept for the next reconnect.
 */
export const refreshSocketAuth = (token: string): void => {
  socket.auth = { token };
  if (socket.connected) {
    socket.emit(WebsocketServerEvent.AUTH_REFRESH, token);
    return;
  }
  // socket.io-client 4.7.5 calls destroy() on a CONNECT_ERROR from a rejected
  // handshake token (an expired one, for instance): `active` turns false and
  // the manager gives up retrying on its own. A fresh token must kick it back
  // into trying — otherwise the socket stays dead until the page reloads.
  if (!socket.active) {
    socket.connect();
  }
};
